import { render, staticRenderFns } from "./EditTheme.vue?vue&type=template&id=32c6b312&scoped=true&"
import script from "./EditTheme.vue?vue&type=script&lang=js&"
export * from "./EditTheme.vue?vue&type=script&lang=js&"
import style0 from "./EditTheme.vue?vue&type=style&index=0&id=32c6b312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6b312",
  null
  
)

export default component.exports